import CanvasHandler from "./CanvasHandler";
import {
  Row,
  MultipleRows,
  RoundTable,
  RectTable,
  Ellipse,
  Rect,
  Triangle,
  Polygon,
  CircleZone,
  RectangleZone,
  PolygonZone,
  Text,
  Icon,
  ActiveSelection
} from "../canvas/designer";
import { FabricEvent } from "../types/FabricCustomType";
import { IObjectDesingner } from "../types/HandlerObjectType";
import { DirectionEnum, ObjectSuperTypesEnum, ObjectTypesEnum } from "../enums";
import { RowSeatHelper } from "../canvas/designer/helpers/RowSeatHelper";
import store from "../redux/store";

class DrawingHandler {
  private objectTypes: any;
  private object: IObjectDesingner;
  public selectedType: string;

  constructor(canvasHandler: CanvasHandler) {
    this.object = null;
    this.objectTypes = {
      row: new Row(canvasHandler),
      multipleRows: new MultipleRows(canvasHandler),
      roundTable: new RoundTable(canvasHandler),
      rectTable: new RectTable(canvasHandler),
      ellipse: new Ellipse(canvasHandler),
      rect: new Rect(canvasHandler),
      triangle: new Triangle(canvasHandler),
      polygon: new Polygon(canvasHandler),
      circleZone: new CircleZone(canvasHandler),
      rectangleZone: new RectangleZone(canvasHandler),
      polygonZone: new PolygonZone(canvasHandler),
      text: new Text(canvasHandler),
      svg: new Icon(canvasHandler),
      activeSelection: new ActiveSelection(canvasHandler),
    };
  }

  public setType(type: string) {
    this.selectedType = type;
    this.object = this.objectTypes[type];
  }

  public onInit() {
    this.object.onInit();
  }

  public onMousedown(event: FabricEvent<MouseEvent>) {
    this.object.onMousedown(event);
  }

  public onMousemove(event: FabricEvent<MouseEvent | TouchEvent>) {
    this.object.onMousemove(event);
  }

  public onMouseup(event: FabricEvent<MouseEvent | TouchEvent>) {
    this.object.onMouseup(event);
  }

  public onMouseDblClick(event: FabricEvent) {
    this.object.onMouseDblClick(event);
  }

  public onRotated(event: FabricEvent) {
    const { target } = event;
    if (target.type === "activeSelection") {
      this.setType(target.type);
      this.object.onRotated(event);
    }
    if (target.superType === "text") {
      return;
    }
    this.updateRowRotation(target);
  }

  public updateProperties(
    selectedItem: any,
    key: string,
    value: any,
    allValues: any,
  ) {
    this.object.updateProperties(
      selectedItem,
      key,
      value,
      allValues
    );
  }

  private normalize360(angle: number) {
    return ((angle % 360) + 360) % 360;
  }

  public shouldFlipRowText(accumulatedAngle: number) {
    const normalized = this.normalize360(accumulatedAngle);
    return normalized >= 90 && normalized < 270;
  }

  public updateRowRotation = (target: any) => {
    const validRotationObjects = [ObjectSuperTypesEnum.RectTable, ObjectSuperTypesEnum.RoundTable, ObjectSuperTypesEnum.Row];
    if(!validRotationObjects.includes(target.superType)) return;

    const previousAccumulated = target.angleHelp || 0;
    const deltaAngle = target.newAngle || 0;
    const accumulatedAngle = previousAccumulated + deltaAngle;
    target.set({
      angleHelp: accumulatedAngle
    });

    target.getObjects().forEach((obj: any) => {
      if (obj.type === "group" && (obj.superType === "seat" || obj.superType === "table")) {
        const seatText = obj.item(1);

        if (
          seatText &&
          (seatText.type === "text" ||
            seatText.type === "i-text" ||
            seatText.type === "textbox")
          ) {
            seatText.set({
              originX: "center",
              originY: "center",
              centeredRotation: true
            })
            seatText.set({
              angle: seatText.angle - target.newAngle
            });
            obj.setCoords();
          }
      }
    });

    // Reposicionamos y reorientamos las etiquetas de fila (B, C, DERP...) con la
    // misma lógica que se usa al editar espaciado/curva/cantidad. En filas
    // viejas la posición base guardada no es consistente con la geometría
    // actual, así que limitarse a voltear el texto las descuadraba al girar.
    // refreshRowLabels recalcula el placement (getCenterPoint + matriz del
    // grupo) y aplica el flip por ángulo, dejándolas pegadas a los extremos.
    if (target.superType === ObjectSuperTypesEnum.Row) {
      const { properties: { rowSeatSize } } = store.getState() as any;
      const textObjs = target.getObjects(ObjectTypesEnum.TextBox) || [];
      const textLeft = textObjs.filter((t: any) => t.side === DirectionEnum.Left);
      const textRight = textObjs.filter((t: any) => t.side === DirectionEnum.Right);

      RowSeatHelper.refreshRowLabels({
        selectedItem: target,
        rowSeatSize,
        textLeft,
        textRight,
        labelOffset: 15,
      });
    }

    target.addWithUpdate();
    target.setCoords();
  };

}

export default DrawingHandler;
